import { render } from "./ButtonComponent.vue?vue&type=template&id=a5c43c30"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=a5c43c30&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__